import {
  chatPublicShareQueryKey,
  OWNED_SHARED_CHATS_QUERY_KEY,
} from "@frontend-shared/constants";
import type { ICreateChatPublicShareBody } from "@frontend-shared/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { chatApi } from "@/api/services";

// NOTE: Mints the link, or — when one is already live — rotates its password in
// place. The same mutation serves both because the server decides which applies:
// the client cannot know whether a link exists without racing its own query.
export const useCreateChatPublicShare = (chatUuid: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: ICreateChatPublicShareBody) =>
      chatApi.createChatPublicShare(chatUuid, body),
    onSuccess: (data) => {
      // NOTE: Write the result straight into the share cache so the query stays
      // the single source of truth for both link and password — no local copy of
      // the freshly minted password, and so no window where a rotated-away one
      // could win over the current.
      queryClient.setQueryData(chatPublicShareQueryKey(chatUuid), data);
      // NOTE: NSAI-3499 — the Profile › Shared chats overview lists it too.
      queryClient.invalidateQueries({
        queryKey: [OWNED_SHARED_CHATS_QUERY_KEY],
      });
    },
    // NOTE: The dialog renders its own error copy (including the rate-limited
    // case), so the global mutation-cache toast would duplicate it.
    meta: { suppressErrorToast: true },
  });
};
